/**
 * @file The archive chips of one report: the distinct `scheduledAt` instants
 * of its runs, newest first, at most six. Consumer: `useAnalyticsReportArchive`.
 * Every recipient's run of one cycle shares the cycle's instant, so an admin's
 * read of several runs per instant collapses to one chip each. An admin read
 * that returned exactly `adminLimit` runs may end inside its oldest instant;
 * that instant is dropped only when it holds fewer runs than the report's
 * current recipients, since a run stores its own recipient and no list.
 * ISO instants written by `Date#toISOString()` sort as text in time order.
 */
import { ANALYTICS_REPORT_ARCHIVE_SIZE } from './ANALYTICS_REPORT_ARCHIVE_SIZE';

export const analyticsReportArchiveDates = (
  runs: readonly { scheduledAt: string }[],
  adminLimit: number | null,
  recipientCount: number,
): string[] => {
  const newestFirst = [...new Set(runs.map(({ scheduledAt }) => scheduledAt))]
    .sort()
    .reverse();
  const oldest = newestFirst.at(-1);
  const isOldestPartial =
    runs.length === adminLimit &&
    runs.filter(({ scheduledAt }) => scheduledAt === oldest).length <
      recipientCount;
  const whole = isOldestPartial ? newestFirst.slice(0, -1) : newestFirst;
  return whole.slice(0, ANALYTICS_REPORT_ARCHIVE_SIZE);
};
